"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dateHelper = require("../../../helpers/dateHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _orderHistoryHelper = require("../../../helpers/orderHistoryHelper");
var _table = require("../../data/table");
var _decimalPlacesHelper = require("../../../helpers/decimalPlaces/decimalPlacesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('order-history-table');
var InactiveOrdersComponent = function InactiveOrdersComponent(props) {
  var t = props.t,
    selectedAccountId = props.selectedAccountId,
    getInactiveOrders = props.getInactiveOrders,
    resetActivePage = props.resetActivePage,
    data = props.data,
    instruments = props.instruments,
    config = props.config,
    fetching = props.fetching,
    selectedInstrument = props.selectedInstrument,
    isFutures = props.isFutures;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  (0, _react.useEffect)(function () {
    if (selectedAccountId) {
      getInactiveOrders(selectedAccountId, props.OMSId, 0);
    }
    return function () {
      resetActivePage('InactiveOrdersComponent');
    };
  }, [selectedAccountId, getInactiveOrders, props.OMSId, resetActivePage]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Pair'),
      dataTest: 'Pair',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref) {
        var row = _ref.row;
        return row.original.instrument.Symbol;
      }
    }, {
      header: t('Side'),
      dataTest: 'Side',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass(row.original.Side === 'Buy' ? 'buy' : 'sell')
        }, t(row.original.Side));
      }
    }, {
      header: t('Type'),
      dataTest: 'Type',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return row.original.IsQuote ? t('Quote') : t(row.original.OrderType);
      }
    }, {
      header: t('Size'),
      dataTest: 'Size',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('size')
        }, row.original.DisplayQuantity && (0, _numberFormatter.formatNumberToLocale)(row.original.DisplayQuantity, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.QuantityIncrement)));
      }
    }].concat(_toConsumableArray(isFutures ? [{
      header: t('Trigger Price'),
      dataTest: 'Trigger Price',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('trigger-price')
        }, (0, _orderHistoryHelper.getFuturesOrderPriceToDisplay)(row.original, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.PriceIncrement)));
      }
    }] : []), [{
      header: t('Price'),
      dataTest: 'Price',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: baseClass('price')
        }, (isFutures ? _orderHistoryHelper.getFuturesOrderPriceToDisplay : _orderHistoryHelper.getOrderPriceToDisplay)(row.original, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(row.original.selectedInstrument.PriceIncrement)));
      }
    }, {
      header: t('Date/Time'),
      dataTest: 'Date/Time',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return (0, _dateHelper.formatDateTime)(row.original.ReceiveTime);
      }
    }, {
      header: t('Status'),
      dataTest: 'Status',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref8) {
        var row = _ref8.row;
        return t(row.original.OrderState);
      }
    }]);
  }, [t, isFutures]);
  var dataWithInstruments = data.map(function (row) {
    return _objectSpread(_objectSpread({}, row), {}, {
      selectedInstrument: selectedInstrument || instruments.find(function (item) {
        return item.InstrumentId === row.Instrument;
      }) || {}
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: dataWithInstruments,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  });
};
InactiveOrdersComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  instruments: _propTypes["default"].array.isRequired,
  getInactiveOrders: _propTypes["default"].func.isRequired,
  resetActivePage: _propTypes["default"].func.isRequired,
  config: _propTypes["default"].object.isRequired,
  fetching: _propTypes["default"].bool.isRequired,
  selectedAccountId: _propTypes["default"].number,
  selectedInstrument: _propTypes["default"].object,
  OMSId: _propTypes["default"].number,
  isFutures: _propTypes["default"].bool
};
var InactiveOrdersTranslated = (0, _reactI18next.withTranslation)('order')(InactiveOrdersComponent);
// t('Inactive Orders', { namespace: 'order' });
InactiveOrdersTranslated.title = 'Inactive Orders';
var _default = exports["default"] = InactiveOrdersTranslated;